import { render, staticRenderFns } from "./Asia.vue?vue&type=template&id=28b17f47&"
import script from "./Asia.vue?vue&type=script&lang=js&"
export * from "./Asia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports